<template>
  <div id="app" class="flex flex-col bg-gray-100 min-h-screen text-gray-600">
    <navbar />
    <div class="container mx-auto flex-grow mt-16">
      <h1 class="text-2xl my-5 font-bold">{{ $route.name }}</h1>
      <router-view />
    </div>
    <Footer />
  </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  }
}
</script>
